module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ios-banner"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'OSS Configs',
          to: {
            path: '/landing-banners'
          },
          exact: true,
        },
        {
          text: 'Banner Ios',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Daftar Banner Ios")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar Banner\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    attrs: {
      "id": "oss_config_ios_banner_tambah",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/ios-banners/form?baru=1'
        })
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Buat Banner\n            ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.Banners,
      "headers": _vm.headers,
      "hasDetail": true,
      "custom-pagination-total-items": _vm.Banners.length,
      "custom-pagination-per-page": 10,
      "custom-pagination-current-page": 1
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editBanner()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f3b0c2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/oss_configs/components/ios_banners/ListBanner.vue
// module id = 1939
// module chunks = 1